<template>
    <wsm :class="[$root.isadmin && translationMode ? 'wsmContainer' : '', active || openTranslator ? 'activeElHoverWsm' : '']">
        <VHTML :html="newText" />
        <transition name="bounce">
            <span class="langBtn" v-if="!loading && $root.isadmin && translationMode" :style="{ 'left': howFarLeft }" @mouseover="active = true;" ref="transIcon" @click="openTranslator = !openTranslator;disableLink()" @mouseleave="active = false" :class="[openTranslator ? 'activeIcon' : '']">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"/></svg>
                                        </span>
        </transition>
        <transition name="bounce">
            <div v-if="openTranslator && $root.isadmin && translationMode" :class="['translateWindow']">
                <span @click="openTranslator = !openTranslator" class="close">X</span>
                <textarea v-model="newText"></textarea>
                <button :class="[error ? 'error' : '']" :disabled="done == true || error" @click="submitTrans">{{error == false ? 'Translate' : 'error'}}</button>
            </div>
        </transition>
    </wsm>
</template>

<script>
import { Component as VHTML } from '@staszek998/v-html'
export default {
    name: 'webmessage',
    props: ["text", "searchKey"],
    components: {
        VHTML
    },
    data() {
        return {
            openTranslator: false,
            loading: true,
            active: false,
            styleDisplay: 'block',
            done: false,
            parentWidth: 0,
            tag: undefined,
            howFarLeft: 0,
            oldTxt: this.text,
            itIsDoneCreating: false,
            newText: '',
            error: false,
            link: '',
            template: '',
        }
    },
    updated() {
        this.template = `${this.newText}`
    },
    watch: {
        openTranslator: function() {
            if (!this.openTranslator) {
                this.enableLink()
            } else {
                this.disableLink();
            }
        }
    },
    mounted() {
        if(typeof this.$root.isadmin == 'undefined' && this.$root.admin) {
            var nameOfApp = (typeof this.$root.$options.name != 'undefined') ? this.$root.$options.name : 'src/main.js or whatever you have called it'
            console.error('['+nameOfApp+'] isadmin is undefined or missing in $root. Your app needs isadmin in $root to check if you are allowed to change a webmessage')
        }
        this.loading = true;
        this.newText = this.oldTxt
        var plep = this;
        window.addEventListener('load', (event) => {
            this.oldTxt = this.text;
            this.newText = this.text;
            this.howFarLeft = window.getComputedStyle(this.$el, null).width
            plep.loading = false;
        })
        if (this.$el.parentElement.getAttribute('href') != null) {
            this.link = this.$el.parentElement.getAttribute('href')
            this.$el.parentElement.addEventListener("click", function(event) {
                if (plep.openTranslator && plep.$el.parentElement.getAttribute('href') != null) {
                    plep.$el.parentElement.removeAttribute('href')
                }
            });
        }

    },
    methods: {
        htmlString(string, tag) {
            return `<` + tag + ` ${(typeof this.classes != 'undefined' ? 'class="'+this.classes+'"' : '')}>${string}</` + tag + `>`;
        },
        submitTrans() {
            axios.post(basedir + '/ajaxRequestServlet?mode=WebMessageAPI', null, {
                params: {
                    fromApp: true,
                    searchKey: this.searchKey,
                    oldMsgTxt: encodeURIComponent(this.oldTxt),
                    newMsgTxt: encodeURIComponent(this.newText),
                    lang: locale,
                }
            }, {
                headers: {
                    'Content-type': 'application/json',
                }
            }).then(response => {
                this.oldTxt = this.newText
                this.openTranslator = false;
            })
        },
        disableLink() {
            if (this.openTranslator && this.$el.parentElement.getAttribute('href') != null) {
                this.$el.parentElement.removeAttribute('href')
            }
        },
        enableLink() {
            setTimeout(() => {
                this.$el.parentElement.setAttribute('href', this.link)
            })

        }
    },
    computed: {
        translationMode() {
            return window.translationMode
        }
    }
}
</script>

<style lang="scss" scoped>
wsm {
    position: relative;
    .langBtn {
        background: white !important;
        box-shadow: 0 0 10px 0 #2e933f !important;
        padding: 4px !important;
        border-radius: 29px !important;
        height: 19px !important;
        box-sizing: unset !important;
        fill: #0ac257 !important;
        width: 23px !important;
        color: #0ac257 !important;
        font-family: "Font Awesome 5 Free" !important;
        font-size: 17px !important;
        vertical-align: sub !important;
        text-align: center !important;
        cursor: pointer !important;
        position: absolute !important;
        padding-top: 7px !important;
        top: -18px !important;
        	z-index: 99999;
        transition: all 0.2s ease-in-out !important;
        &:hover {
            transform: scale(1.1);
        }
        &.activeIcon {
            background: #0ac257 !important;
            fill: white !important;
        }
    }
}

.activeElHoverWsm {
    border: 2px solid #0ac257;
    border-radius: 11px;
    padding: 5px;
    transition: padding 0.1s ease-in-out;
}

.wsmContainer {
    position: relative;
    display: inline-block;
    width: auto;
    &>* {
        display: inline-block;
    }
    .translateWindow {
        position: absolute;
        right: -325px;
        top: -25px;
        background: #eae1cc;
        padding: 12px;
        box-shadow: 0 0 14px 4px #00000066;
        border-radius: 8px;
        	z-index: 99999999;
        height: auto !important;
        width: 271px;
        input {
            padding: 5px;
            font-weight: bold;
        }
        textarea {
            width: 98%;
            height: 149px;
        }
        button {
            width: 100%;
            padding: 5px;
            margin-top: 10px;
            font-size: 15px;
            border: none;
            background: #0ac257;
            cursor: pointer;
            color: white;
            &:hover {
                background: #1fcf69;
            }
        }
        .error {
            background: #e94949;
        }
    }
    .isTextArea {
        width: 374px;
    }
}

.close {
    position: absolute;
    right: -12px;
    background: #f06363;
    top: -12px;
    border-radius: 30px;
    width: 21px;
    height: 22px;
    text-align: center;
    padding: 2px;
    cursor: pointer;
    padding-left: 4px;
    color: white;
    font-weight: bold;
}

.bounce-enter-active {
    animation: bounce-in .5s;
}

.bounce-leave-active {
    animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}
</style>